import React, { useState, useEffect } from 'react';
import { Table, Input, Modal, Tag } from 'antd';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import api from '../services/api';
import './css/searchComponent.css';

const { Search } = Input;
const isMobile = window.innerWidth <= 768;
const mobileSearchClass = isMobile ? 'custom-search-mobile' : '';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0, showSizeChanger: true, pageSizeOptions: ['5', '10', '20', '50', '100'] });
  const [searchText, setSearchText] = useState('');
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const fetchLogs = async (page = 1, search = '', pageSize = 5) => {
    setLoading(true);
    try {
      const response = await api.get('/audit-logs', {
        params: { page, limit: pageSize, search }
      });
      setLogs(response.data.data);
      setPagination(prev => ({ ...prev, total: response.data.total, current: page, pageSize }));
    } catch (error) {
      console.error('Erro ao carregar logs');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleTableChange = (pag) => {
    const newPage = pag.pageSize !== pagination.pageSize ? 1 : pag.current;
    fetchLogs(newPage, searchText, pag.pageSize);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setPagination(prev => ({ ...prev, current: 1 }));
    fetchLogs(1, value, 5);
  };

  const showDetail = (log) => {
    setSelectedLog(log);
    setDetailModalVisible(true);
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'CREATE': return 'green';
      case 'UPDATE': return 'blue';
      case 'DELETE': return 'red';
      default: return 'default';
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80, sorter: (a, b) => a.id - b.id },
    { title: 'Usuário', dataIndex: 'username', key: 'username', sorter: (a, b) => a.username?.localeCompare(b.username) },
    { 
      title: 'Ação', 
      dataIndex: 'action', 
      key: 'action', 
      render: (action) => <Tag color={getActionColor(action)}>{action}</Tag>,
      sorter: (a, b) => a.action?.localeCompare(b.action)
    },
    { title: 'Tabela', dataIndex: 'table_name', key: 'table_name', sorter: (a, b) => a.table_name?.localeCompare(b.table_name) },
    { title: 'Registro ID', dataIndex: 'record_id', key: 'record_id', sorter: (a, b) => a.record_id - b.record_id },
    { title: 'IP', dataIndex: 'ip_address', key: 'ip_address', sorter: (a, b) => a.ip_address?.localeCompare(b.ip_address) },
    { 
      title: 'Data/Hora', 
      dataIndex: 'created_at', 
      key: 'created_at', 
      render: (value) => value ? new Date(value).toLocaleString('pt-BR') : '',
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at)
    },
    {
      title: 'Detalhes',
      key: 'details',
      render: (_, record) => (
        <EyeOutlined 
          style={{ cursor: 'pointer', color: '#1890ff' }}
          onClick={() => showDetail(record)}
        />
      ),
    },
  ];

  return (
    <div>
      <div style={{
        marginBottom: 16,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 12 : 0,
        justifyContent: 'space-between',
        alignItems: isMobile ? 'stretch' : 'center'
      }}>
        <Search
          className={mobileSearchClass}
          placeholder="Buscar logs..."
          allowClear
          enterButton={<SearchOutlined />}
          onSearch={handleSearch}
          style={{ width: isMobile ? '100%' : 300 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={logs}
        rowKey="id"
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        scroll={{ x: 800 }}
        showSorterTooltip={false}
      />

      <Modal
        title="Detalhes do Log"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={null}
        width={800}
      >
        {selectedLog && (
          <div>
            <p><strong>ID:</strong> {selectedLog.id}</p>
            <p><strong>Usuário:</strong> {selectedLog.username}</p>
            <p><strong>Ação:</strong> <Tag color={getActionColor(selectedLog.action)}>{selectedLog.action}</Tag></p>
            <p><strong>Tabela:</strong> {selectedLog.table_name}</p>
            <p><strong>Registro ID:</strong> {selectedLog.record_id}</p>
            <p><strong>IP:</strong> {selectedLog.ip_address}</p>
            <p><strong>User Agent:</strong> {selectedLog.user_agent}</p>
            <p><strong>Data/Hora:</strong> {new Date(selectedLog.created_at).toLocaleString('pt-BR')}</p>
            
            {selectedLog.old_data && (
              <div style={{ marginTop: 16 }}>
                <strong>Dados Antigos:</strong>
                <pre style={{ background: '#f5f5f5', padding: 8, borderRadius: 4, fontSize: 12, overflow: 'auto' }}>
                  {JSON.stringify(selectedLog.old_data, null, 2)}
                </pre>
              </div>
            )}
            
            {selectedLog.new_data && (
              <div style={{ marginTop: 16 }}>
                <strong>Dados Novos:</strong>
                <pre style={{ background: '#f5f5f5', padding: 8, borderRadius: 4, fontSize: 12, overflow: 'auto' }}>
                  {JSON.stringify(selectedLog.new_data, null, 2)}
                </pre>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AuditLogs;